import React from 'react';
import classes from './OptionList.module.scss';
import Badge from 'react-bootstrap/Badge';

const OptionList = ({ answers, ...props }) => {
  const options = props.element.options;
  const answerType = props.element.answerType;
  const t = props.t;

  const renderPills = (pills) => {
    return pills.map((pill, index) => {
      return (
        <Badge key={index} pill>
          <h5 data-cy={`${pill.replace(/\s+/g, '-').toLowerCase()}`}>{t(pill, { answers: answers })}</h5>
        </Badge>
      );
    });
  };

  const isSelected = (option) => {
    if (option.value.length) {
      return option.value.every((v) => answers[answerType]?.includes(v));
    } else {
      return answers[answerType]?.length == 0;
    }
  };

  return (
    <>
      <div>
        {options.map((option, index) => {
          return (
            <React.Fragment key={index}>
              <div
                className={`${isSelected(option) ? classes.active : ''} ${classes.optionList}`}
                onClick={() => props.onSelect(answerType, option.value)}
                data-cy={option.value.length > 0 ? `${option.value[0].replace(/\s+/g, '-').toLowerCase()}` : 'none'}
              >
                {option.pill && renderPills(option.pill)}
                <div
                  className={`${isSelected(option) ? classes.openCardActive : ''} ${classes.optionCard}`}
                  data-cy={option.value.length > 0 ? `option-${option.value[0].replace(/\s+/g, '-').toLowerCase()}` : 'option-none'}
                >
                  {t(option.label, { answers: answers })}
                </div>
              </div>
            </React.Fragment>
          );
        })}
      </div>
    </>
  );
};

export default OptionList;
